/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export function generateOrganizerPassword(): string {
  const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz1234578";
  const limit = 256 - (256 % alphabet.length);
  const characters: string[] = [];
  while (characters.length < 12) {
    const bytes = crypto.getRandomValues(new Uint8Array(24));
    for (const value of bytes) {
      if (value < limit) characters.push(alphabet[value % alphabet.length]);
      if (characters.length === 12) break;
    }
  }
  return Array.from({ length: 4 }, (_, group) =>
    characters.slice(group * 3, group * 3 + 3).join(""),
  ).join("-");
}
